import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ValuationTableV1 from './components/ValuationTableV1';
import ValuationTableV2 from './components/ValuationTableV2';
import Navigation from './components/Navigation';
import { generateAssets, calculateTotalValue, generateEntities, generateEntityGroup } from './data/testData';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  const assets = generateAssets();
  const entities = generateEntities();
  const entityGroup = generateEntityGroup();
  const totalValue = calculateTotalValue(assets);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Box sx={{ display: 'flex', bgcolor: 'grey.100', minHeight: '100vh' }}>
            <Navigation />
            <Box 
              component="main"
              sx={{ 
                flexGrow: 1, 
                p: 3,
                width: '100%'
              }}
            >
              <Box sx={{ width: '100%' }}>
                <Routes>
                  <Route path="/" element={<Navigate to="/version1" replace />} />
                  <Route 
                    path="/version1" 
                    element={
                      <ValuationTableV1 
                        assets={assets} 
                        entities={entities}
                        entityGroup={entityGroup}
                        totalValue={totalValue} 
                      />
                    } 
                  />
                  <Route 
                    path="/version2" 
                    element={
                      <ValuationTableV2 
                        assets={assets} 
                        entities={entities}
                        entityGroup={entityGroup}
                        totalValue={totalValue} 
                      />
                    } 
                  />
                </Routes>
              </Box>
            </Box>
          </Box>
        </Router>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App
